import { render, staticRenderFns } from "./QuestionnaireFormQuestion.vue?vue&type=template&id=877d4836"
import script from "./QuestionnaireFormQuestion.vue?vue&type=script&lang=js"
export * from "./QuestionnaireFormQuestion.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireFormQuestion.vue?vue&type=style&index=0&id=877d4836&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports